const account_center = {
    not_enabled: 'Centrum konta nie jest aktywowane.',
    field_not_editable: 'Pole nie jest edytowalne.',
    field_not_enabled: 'Pole nie jest aktywowane.',
};
export default Object.freeze(account_center);
